"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _EmptyLayoutServices = require("./EmptyLayoutServices");
Object.keys(_EmptyLayoutServices).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _EmptyLayoutServices[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _EmptyLayoutServices[key];
    }
  });
});
